export default "__VITE_ASSET__Ch2qIiUc__"